/* jshint -W024 */
if (App.Eros.Config.general.benchmarkJS) console.time("ssr-base: parse imports"); // eslint-disable-line no-console
import Vue from "vue";

// =========================
// COMPONENTS
// =========================

// BASE
import LazyImg from "./app/eros/components/common/LazyImg.vue";
import Intersect from "./app/ceres/components/common/Intersect.vue";
import LazyLoad from "./app/ceres/components/common/LazyLoad.vue";
import AbtestCurtain from "./app/eros/components/common/AbtestCurtain.vue";
import ReCaptcha from "./app/ceres/components/customer/ReCaptcha.vue";

// legacy non-shopbuilder component
import UserLoginHandler from "./app/eros/components/customer/login/UserLoginHandler.vue";

import ItemSearch from "./app/eros/components/itemList/ItemSearch.vue";

import CookieBar from "./app/eros/components/pageDesign/CookieBar.vue";
import Icon from "./app/eros/components/pageDesign/Icon.vue";
import LanguageDetection from "./app/eros/components/pageDesign/LanguageDetection.vue";
import MobileNavigation from "./app/eros/components/pageDesign/MobileNavigation.vue";
import Notifications from "./app/ceres/components/pageDesign/Notifications.vue";
import Popper from "./app/eros/components/pageDesign/Popper.vue";
import LoadingAnimation from "./app/ceres/components/pageDesign/LoadingAnimation.vue";

// EXTERNAL
import LazyHydrate from "vue-lazy-hydration";
import ClientOnly from "./app/ceres/components/common/ClientOnly.vue";
import script2 from "./app/ceres/plugins/script2";

// =========================
// SERVICES
// =========================
import TranslationService from "./app/ceres/services/TranslationService";

// =========================
// MIXINS
// =========================
import "./app/ceres/mixins/template.mixin";
import "./app/ceres/mixins/getJsonData.mixin";

// =========================
// DIRECTIVES
// =========================
import "./app/ceres/directives/basket/basketItemQuantity";
import "./app/ceres/directives/basket/basketItemSum";
import "./app/ceres/directives/basket/toggleBasketPreview";
import "./app/ceres/directives/category/openFilterToolbar";
import "./app/ceres/directives/common/truncateTooltip";
import "./app/eros/directives/customer/logout";
import "./app/eros/directives/helper/populateStoreBase";
import "./app/ceres/directives/helper/validate";
import "./app/ceres/directives/helper/waitingAnimation";
import "./app/eros/directives/helper/waitingAnimationInfinite";
import "./app/eros/directives/helper/mutationObserver";
import "./app/ceres/directives/navigation/navigationTouchHandler";
import "./app/eros/directives/navigation/openMobileNavigation";
import "./app/eros/directives/header/openLanguageControl";
import "./app/ceres/directives/pageDesign/scrollToTop";
import "./app/ceres/directives/pageDesign/stickInParent";
import "./app/eros/directives/navigation/sidenavigationChildrenLoader";
import "./app/eros/directives/pageDesign/tooltip";

// =========================
// FILTERS
// =========================
import "./app/ceres/filters/arrayFirst.filter";
import "./app/eros/filters/currency.filter";
import "./app/ceres/filters/date.filter";
import "./app/ceres/filters/graduatedPrice.filter";
import "./app/ceres/filters/hasItemDefaultPrice.filter";
import "./app/ceres/filters/inputUnit.filter";
import "./app/ceres/filters/itemBundleName.filter";
import "./app/ceres/filters/itemCrossPrice.filter";
import "./app/ceres/filters/itemImage.filter";
import "./app/ceres/filters/itemImageHeight.filter";
import "./app/ceres/filters/itemImageWidth.filter";
import "./app/ceres/filters/itemImageAlternativeText.filter";
import "./app/ceres/filters/itemImages.filter";
import "./app/ceres/filters/itemName.filter";
import "./app/ceres/filters/itemPrice.filter";
import "./app/ceres/filters/itemUrl.filter";
import "./app/ceres/filters/numberFormat.filter";
import "./app/ceres/filters/propertySurcharge.filter";
import "./app/ceres/filters/propertyFileUrl.filter";
import "./app/ceres/filters/translate.filter";
import "./app/ceres/filters/truncate.filter";
import "./app/eros/filters/itemImagesUrlOverwrite.filter";

// =========================
// EROS
// =========================
import CategoryContent from "./app/eros/components/common/CategoryContent.vue";
import Prefetch from "./app/eros/components/common/Prefetch.vue";
import DynamicItemList from "./app/eros/components/itemList/dynamicItemList/DynamicItemList.vue";

// async import by default
// import Registration from "./app/eros/components/customer/Registration.vue";
// import ResetPasswordForm from "./app/eros/components/customer/ResetPasswordForm.vue";
// import ForgotPassword from "./app/eros/components/customer/login/ForgotPassword.vue";
// import GuestLogin from "./app/eros/components/customer/login/GuestLogin.vue";
// import Login from "./app/eros/components/customer/login/Login.vue";
import LoginView from "./app/eros/components/customer/login/LoginView.vue";
import BackgroundImg from "./app/ceres/components/common/BackgroundImg.vue";
// import ShippingCountrySelect from "./app/eros/components/pageDesign/ShippingCountrySelect.vue";
import BasketPreview from "./app/eros/components/basket/BasketPreview.vue";
import ReturnCountrySelect from "./app/eros/components/common/ReturnCountrySelect.vue";
import SliderCarousel from "./app/eros/components/common/SliderCarousel.vue";
import BrevoNewsletterForm from "./app/eros/components/common/BrevoNewsletterForm.vue";

if (App.Eros.Config.general.benchmarkJS) console.timeEnd("ssr-base: parse imports"); // eslint-disable-line no-console

export function beforeCreate() {
	// =========================
	// COMPONENTS
	// =========================

	// BASE
	if (App.Eros.Config.general.benchmarkJS) console.time("ssr-base: set base components"); // eslint-disable-line no-console
	Vue.component("basket-preview", BasketPreview);
	Vue.component("basket-totals", () => import("./app/eros/components/basket/BasketTotals.vue"));
	Vue.component("basket-list", () => import("./app/eros/components/basket/list/BasketList.vue"));
	Vue.component("step-by-step-navigation", () => import("./app/eros/components/category/StepByStepNavigation.vue"));
	Vue.component("lazy-img", LazyImg);
	Vue.component("intersect", Intersect);
	Vue.component("last-seen-item-list", () => import("./app/ceres/components/containers/LastSeenItemList.vue"));
	Vue.component("recaptcha", ReCaptcha);
	Vue.component("registration", () => import("./app/eros/components/customer/Registration.vue"));
	Vue.component("reset-password-form", () => import("./app/eros/components/customer/ResetPasswordForm.vue"));
	Vue.component("forgot-password-modal", () => import("./app/eros/components/customer/login/ForgotPassword.vue"));
	Vue.component("guest-login", () => import("./app/eros/components/customer/login/GuestLogin.vue"));
	Vue.component("login", () => import("./app/eros/components/customer/login/Login.vue"));
	Vue.component("login-view", LoginView);
	Vue.component("user-login-handler", UserLoginHandler);
	Vue.component("category-item", () => import("./app/eros/components/itemList/CategoryItem.vue"));
	Vue.component("quantity-input", () => import("./app/eros/components/item/QuantityInput.vue"));
	Vue.component("item-search", ItemSearch);
	Vue.component("search-suggestion-item", () => import("./app/ceres/components/itemList/SearchSuggestionItem.vue"));
	Vue.component("item-filter-list", () => import("./app/eros/components/itemList/filter/ItemFilterList.vue"));
	Vue.component("item-filter-tag-list", () => import("./app/ceres/components/itemList/filter/ItemFilterTagList.vue"));
	Vue.component("cookie-bar", CookieBar);
	Vue.component("privacy-settings", () => import("./app/ceres/components/pageDesign/PrivacySettings.vue"));
	Vue.component("carousel", () => import("./app/ceres/components/pageDesign/Carousel.vue"));
	Vue.component("slider-carousel", SliderCarousel);
	Vue.component("icon", Icon);
	Vue.component("language-detection", LanguageDetection);
	Vue.component("mobile-navigation", MobileNavigation);
	Vue.component("notifications", Notifications);
	Vue.component("popper", Popper);
	Vue.component("shipping-country-select", () => import("./app/eros/components/pageDesign/ShippingCountrySelect.vue"));
	Vue.component("loading-animation", LoadingAnimation);
	Vue.component("lazy-load", LazyLoad);
	Vue.component("abtest-curtain", AbtestCurtain);
	Vue.component("client-only", ClientOnly);
	Vue.component("background-img", BackgroundImg);
	if (App.Eros.Config.general.benchmarkJS) console.timeEnd("ssr-base: set base components"); // eslint-disable-line no-console

	// EROS
	if (App.Eros.Config.general.benchmarkJS) console.time("ssr-base: set eros components"); // eslint-disable-line no-console
	Vue.component("exchange-rate", () => import("./app/eros/components/common/ExchangeRate.vue"));
	Vue.component("dynamic-item-list", DynamicItemList);
	Vue.component("dynamic-item-list-common", () =>
		import("./app/eros/components/itemList/dynamicItemList/Common/DynamicItemListCommon.vue")
	);
	// since basket isn't tpl.basket
	Vue.component("dynamic-item-list-basket-tag", () =>
		import("./app/eros/components/itemList/dynamicItemList/Basket/DynamicItemListBasketTag.vue")
	);
	Vue.component("dynamic-item-list-basket-prop", () =>
		import("./app/eros/components/itemList/dynamicItemList/Basket/DynamicItemListBasketProp.vue")
	);
	Vue.component("dynamic-item-list-basket-simple", () =>
		import("./app/eros/components/itemList/dynamicItemList/Basket/DynamicItemListBasketSimple.vue")
	);
	Vue.component("event-tracker", () => import("./app/eros/components/common/EventTracker.vue"));
	Vue.component("category-content", CategoryContent);
	Vue.component("prefetch", Prefetch);
	Vue.component("dynamic-item-list-item-tag", () =>
		import("./app/eros/components/itemList/dynamicItemList/Item/DynamicItemListItemTag.vue")
	);
	Vue.component("dynamic-item-list-item-attr-cross", () =>
		import("./app/eros/components/itemList/dynamicItemList/Item/DynamicItemListItemAttrCross.vue")
	);
	Vue.component("dynamic-item-list-item-variation-session", () =>
		import("./app/eros/components/itemList/dynamicItemList/Item/DynamicItemListItemVariationSession.vue")
	);
	Vue.component("return-country-select", ReturnCountrySelect);
	Vue.component("return-label", () => import("./app/eros/components/common/ReturnLabel.vue"));
	Vue.component("brevo-newsletter-form", BrevoNewsletterForm);
	if (App.Eros.Config.general.benchmarkJS) console.timeEnd("ssr-base: set eros components"); // eslint-disable-line no-console

	// EXTERNAL
	if (App.Eros.Config.general.benchmarkJS) console.time("ssr-base: set external components"); // eslint-disable-line no-console
	Vue.component("lazy-hydrate", LazyHydrate);
	Vue.use(script2);
	if (App.Eros.Config.general.benchmarkJS) console.timeEnd("ssr-base: set external components"); // eslint-disable-line no-console

	if (App.Eros.Config.general.benchmarkJS) console.time("ssr-base: link translation and app to vue object"); // eslint-disable-line no-console
	Vue.prototype.$translate = TranslationService.translate;
	Vue.prototype.$ceres = App;
	if (App.Eros.Config.general.benchmarkJS) console.timeEnd("ssr-base: link translation and app to vue object"); // eslint-disable-line no-console
}

export function createApp(options, store) {
	const defaultOptions = {
		store,
		...options,
		data: () => {
			return { prefetch: false };
		}
	};

	if (App.Eros.Config.general.benchmarkJS) console.time("ssr-base: create new Vue"); // eslint-disable-line no-console
	const app = new Vue(defaultOptions);

	if (App.Eros.Config.general.benchmarkJS) console.timeEnd("ssr-base: create new Vue"); // eslint-disable-line no-console

	return app;
}
